import { createContext, useContext, useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from './AuthContext'

const WeddingContext = createContext({})

export function WeddingProvider({ children }) {
  const { user } = useAuth()
  const [wedding, setWedding] = useState(null)
  const [events, setEvents] = useState([])
  const [loadingWedding, setLoadingWedding] = useState(true)

  useEffect(() => {
    if (user) {
      fetchWedding()
    } else {
      setWedding(null)
      setEvents([])
      setLoadingWedding(false)
    }
  }, [user])

  async function fetchWedding() {
    if (!user?.id) return
    setLoadingWedding(true)
    try {
      const { data, error } = await supabase
        .from('weddings')
        .select('*, wedding_events(*)')
        .or(`partner1_id.eq.${user.id},partner2_id.eq.${user.id}`)
        .order('created_at', { ascending: false })
        .limit(1)

      if (error) throw error

      const wedding = data?.[0] || null
      if (wedding) {
        setWedding(wedding)
        setEvents(wedding.wedding_events || [])
      } else {
        setWedding(null)
        setEvents([])
      }
    } catch (err) {
      console.error('WeddingContext: failed to load wedding')
      setWedding(null)
      setEvents([])
    } finally {
      setLoadingWedding(false)
    }
  }

  const isPremium = wedding?.plan === 'premium'

  return (
    <WeddingContext.Provider value={{ wedding, events, loadingWedding, refreshWedding: fetchWedding, isPremium }}>
      {children}
    </WeddingContext.Provider>
  )
}

export const useWedding = () => useContext(WeddingContext)
